import { render, staticRenderFns } from "./designTree.vue?vue&type=template&id=6d233928&scoped=true"
import script from "./designTree.vue?vue&type=script&lang=js"
export * from "./designTree.vue?vue&type=script&lang=js"
import style0 from "./designTree.vue?vue&type=style&index=0&id=6d233928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d233928",
  null
  
)

export default component.exports